import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* retrySendbirdBatchMessage({ payload: { id, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.multi_message.retry, id });

    onSuccess && onSuccess(data.result);
    yield put(actions.retrySendbirdBatchMessageDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.retrySendbirdBatchMessageFailed,
      handledErrors,
      endpoint: api.sendbird.multi_message.retry.url
    });
  }
}

export const retrySendbirdBatchMessageSaga = takeEvery(types.RETRY_SENDBIRD_BATCH_MESSAGE_REQUEST, retrySendbirdBatchMessage);